/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
    MaterialReactTable,
    useMaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
} from 'material-react-table';

import {
    Box,
    Button,
    Dialog,
    ListItemIcon,
    MenuItem,
    LinearProgress,
    Menu,
    lighten,

} from '@mui/material';

import { Edit } from '@mui/icons-material'; // Only keeping Edit for now, as View/Delete were removed for listings
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';
import { Snackbar, Alert } from '@mui/material';
import FormComponent from './MaterialReactTableModals/FormComponent'; // Assuming FormComponent handles general data
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import assets from "assets";


const MAX_EXPORT_LIMIT = 5000;

const Material_React_Table = ({
    data = [], // This prop will now contain enquiry data
    allData = [],
    onRowUpdate, // Keep this for the 'Edit' modal
    userInitialState, // Keep this for initial table state
    unArchive,
    archive,
    navigateToCreateEnquiry,
    edit,
    pullforward,
}) => {
    const navigate = useNavigate();
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const exportMenuOpen = Boolean(exportAnchorEl);
    const getValue = (val, fallback = 'N/A') => val ?? fallback;
    const [pdfAnchorEl, setPdfAnchorEl] = useState(null);
    const [isExporting, setIsExporting] = useState(false);
    // Define columns for Enquiry data based on the provided JSON structure
    const enquiryColumns = useMemo(
        () => [
            { accessorKey: 'id', header: 'ID', size: 100 },
            { accessorKey: 'CompanyName', header: 'Company Name', size: 150 },
            {
                accessorKey: 'CreatedAt',
                header: 'Created At',
                Cell: ({ cell }) => new Date(getValue(cell.getValue(), Date.now())).toLocaleDateString(),
                size: 100,
            },
            { accessorKey: 'Email', header: 'Email', size: 150 },
            { accessorKey: 'OwnerName', header: 'Owner Name', size: 150 },
            { accessorKey: 'PhoneNumber', header: 'Phone Number', size: 120 },
            { accessorKey: 'userdetials.Name', header: 'User', size: 120 }, // Nested access
            { accessorKey: 'address.suburb', header: 'Suburb', size: 200 }, // Nested access
            {
                accessorKey: 'enquiryDate',
                header: 'Enquiry Date',
                Cell: ({ cell }) => new Date(getValue(cell.getValue(), Date.now())).toLocaleDateString(),
                size: 100,
            },
            { accessorKey: 'office', header: 'Office', size: 100 },
            { accessorKey: 'source', header: 'Source', size: 100 },
            { accessorKey: 'status', header: 'Status', size: 120 },
            { accessorKey: 'type', header: 'Type', size: 100 },
            { accessorKey: 'typeOfProperty', header: 'Property Type', size: 150 },
            { accessorKey: 'sizeMin', header: 'Min Size', size: 100 },
            { accessorKey: 'sizeMax', header: 'Max Size', size: 100 },
        ],
        [],
    );


    const handleOpenModal = (type, rowData = null) => {
        setModalType(type);
        setSelectedRow(rowData);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedRow(null);
    };

    const handleFormSubmit = (values) => {
        if (modalType === 'edit') {
            onRowUpdate(values);
        }
        handleCloseModal();
    };

    const handleExportClick = (event) => {
        setExportAnchorEl(event.currentTarget);
    };

    const handleExportClose = () => {
        setExportAnchorEl(null);
    };

    const handleExport = (table, type = 'filtered') => {
    setIsExporting(true);
    let rows = [];
    let rowsToExport = [];

    console.log('type', type);

        // Decide source of rows based on requested export type
        if (type === 'page') {
            // current page rows
            rowsToExport = table.getPaginationRowModel().rows.map(row => row.original);
        } else if (type === 'filtered') {
            // all rows after filtering/sorting but before pagination
            // this respects the active column/global filters applied in the table
            const prePaginated = table.getPrePaginationRowModel?.() || table.getFilteredRowModel?.();
            rowsToExport = (prePaginated?.rows || []).map(row => row.original);
        } else if (type === 'all') {
            // all data passed from parent (server/full dataset)
            rowsToExport = allData || [];
        }

        if (!rowsToExport.length) {
            setSnackbarMessage('No enquiry data to export.'); // Name change
            setSnackbarOpen(true);
            setIsExporting(false);
            return;
        }

        if (rowsToExport.length > MAX_EXPORT_LIMIT && type !== 'all') {
            rowsToExport = rowsToExport.slice(0, MAX_EXPORT_LIMIT);
            setSnackbarMessage(`Only ${MAX_EXPORT_LIMIT} enquiries were exported due to size limits.`);
            setSnackbarOpen(true);
        }

        const wb = XLSX.utils.book_new();

        // Adapt export sheet data for Enquiries
        const exportSheetData = rowsToExport.map(enquiry => {
            const address = enquiry.address || {};
            const userdetials = enquiry.userdetials || {};
            // Notes may be stored in notes or additionalNotes depending on UI
            const notes = enquiry.additionalNotes ?? enquiry.notes ?? '';
            // Additional contact fields used in createEnquiry/StaffUpdateEnquiry
            const addedClientName = enquiry.addedClientName || enquiry.addedContactName || '';
            const addedContactNumber = enquiry.addedContactNumber || enquiry.addedContactNumberFull || enquiry.addedContactNumber || '';
            const addedEmail = enquiry.AddedEmail || enquiry.addedContactEmail || enquiry.addedEmail || '';
            const createdAtDate = new Date(getValue(enquiry.CreatedAt, Date.now())).toLocaleDateString();
            const enquiryDate = new Date(getValue(enquiry.enquiryDate, Date.now())).toLocaleDateString();

            return {
                // Excel spec: remove ID, remove user (broker) email; add notes and additional contact details
                "Company Name": getValue(enquiry.CompanyName),
                "Created At": createdAtDate,
                "Email": getValue(enquiry.Email),
                "Owner Name": getValue(enquiry.OwnerName),
                "Phone Number": getValue(enquiry.PhoneNumber),
                "User": getValue(userdetials.Name),
                // "User Email" removed per spec
                "Suburb": getValue(address.suburb),
                "Enquiry Date": enquiryDate,
                "Source": getValue(enquiry.source),
                "Status": getValue(enquiry.status),
                "Type": getValue(enquiry.type),
                "Property Type": getValue(enquiry.typeOfProperty),
                "Min Size": getValue(enquiry.sizeMin),
                "Max Size": getValue(enquiry.sizeMax),
                // New fields
                "Notes": getValue(notes, ''),
                "Additional Contact Name": getValue(addedClientName, ''),
                "Additional Contact Number": getValue(addedContactNumber, ''),
                "Additional Contact Email": getValue(addedEmail, ''),
            };
        });

        const exportSheetColumnsOrder = [
            "Company Name", "Created At", "Email", "Owner Name", "Phone Number",
            "User", "Suburb", "Enquiry Date", "Source",
            "Status", "Type", "Property Type", "Min Size", "Max Size",
            "Notes", "Additional Contact Name", "Additional Contact Number", "Additional Contact Email"
        ];

        const addSheetToWorkbook = (dataArray, sheetName, headers = null) => {
            const ws = dataArray.length
                ? XLSX.utils.json_to_sheet(dataArray, { header: headers })
                : XLSX.utils.aoa_to_sheet([[]]);
            XLSX.utils.book_append_sheet(wb, ws, sheetName);
        };

        addSheetToWorkbook(exportSheetData, 'Enquiries', exportSheetColumnsOrder); // Sheet name change

        // Include timestamp in filename to avoid browser caching/overwrite issues
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        XLSX.writeFile(wb, `Enquiries_${type}_Export_${timestamp}.xlsx`); // Filename change
        setIsExporting(false);
    };

    // Helper function to get criteria summary from table state (adapted for enquiries)
    const getCriteriaSummary = (table) => {
        const state = table.getState();
        const columnFilters = state.columnFilters;
        const globalFilter = state.globalFilter;
        const sorting = state.sorting;
        const grouping = state.grouping;

        let enquiryStatus = 'All'; // Changed to enquiry specific
        let enquiryTypes = 'All'; // Placeholder
        let branches = 'All';
        let agents = 'All';
        let propertyTypes = 'All'; // For typeOfProperty
        let areas = 'All'; // For address.suburb
        let groupedBy = 'None';
        let sortedBy = 'None';

        columnFilters.forEach(filter => {
            if (filter.id === 'status') {
                enquiryStatus = filter.value || 'All';
            }
            if (filter.id === 'type') { // Assuming 'type' for general enquiry type
                enquiryTypes = filter.value || 'All';
            }
            if (filter.id === 'office') {
                branches = filter.value || 'All';
            }
            if (filter.id === 'userdetials.Name') {
                agents = filter.value || 'All';
            }
            if (filter.id === 'typeOfProperty') {
                propertyTypes = filter.value || 'All';
            }
            if (filter.id === 'address.suburb') {
                areas = filter.value || 'All';
            }
        });

        if (sorting && sorting.length > 0) {
            const primarySort = sorting[0];
            const column = table.getColumn(primarySort.id);
            if (column) {
                sortedBy = `${column.header} - ${primarySort.desc ? 'Descending' : 'Ascending'}`;
                if (primarySort.id === 'CreatedAt' || primarySort.id === 'enquiryDate') {
                    sortedBy = `Date Added - ${primarySort.desc ? 'Newest First' : 'Oldest First'}`;
                }
            }
        }

        if (grouping && grouping.length > 0) {
            groupedBy = grouping.map(id => table.getColumn(id)?.header || id).join(', ');
        }

        // Construct the string based on the requested format, adapted for enquiries
        return `Enquiry Status: ${enquiryStatus} | Enquiry Types: ${enquiryTypes} | Branches: ${branches} | Agents: ${agents} | Property Types: ${propertyTypes} | Areas: ${areas} | Grouped By: ${groupedBy} | Sorted By: ${sortedBy}`;
    };


    const loadImageAsBase64 = (src) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png");
                resolve(dataURL);
            };
            img.onerror = reject;
            img.src = assets.logo138x75black;
        });
    };


    const handleExportPDF = async (table, type = 'filtered') => {
        setIsExporting(true);
        let rowsToExport = [];

        if (type === 'page') {
            rowsToExport = table.getPaginationRowModel().rows.map(row => row.original);
        } else if (type === 'filtered') {
            const prePaginated = table.getPrePaginationRowModel?.() || table.getFilteredRowModel?.();
            rowsToExport = (prePaginated?.rows || []).map(row => row.original);
        } else if (type === 'all') {
            rowsToExport = allData || [];
        }

        if (!rowsToExport.length) {
            setSnackbarMessage('No enquiry data to export.'); // Name change
            setSnackbarOpen(true);
            setIsExporting(false);
            return;
        }

        if (rowsToExport.length > MAX_EXPORT_LIMIT && type !== 'all') {
            rowsToExport = rowsToExport.slice(0, MAX_EXPORT_LIMIT);
            setSnackbarMessage(`Only ${MAX_EXPORT_LIMIT} enquiries were exported due to size limits.`);
            setSnackbarOpen(true);
        }

        const doc = new jsPDF('landscape');
        const pageWidth = doc.internal.pageSize.width;
        const headerHeight = 25;
        const headerColor = [0, 153, 255];

        // Blue header box
        doc.setFillColor(...headerColor);
        doc.rect(0, 0, pageWidth, headerHeight, 'F');
        doc.setTextColor(255, 255, 255);

        // Header Titles
        doc.setFontSize(14);
        doc.setFont('helvetica', 'normal');

        doc.text('Commercial Activity Report', pageWidth - 14, headerHeight / 2 + 2, { align: 'right' });

        // Date and Time
        doc.setFontSize(8);
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
        const formattedTime = currentDate.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).replace(':', '');
        doc.text(`${formattedDate}, ${formattedTime}`, pageWidth - 14, headerHeight / 2 + 10, { align: 'right' });


        // --- Content between Header and Table ---
        doc.setTextColor(0, 0, 0); // Reset text color to black
        doc.setFont('helvetica', 'normal');

        let currentY = headerHeight + 10; // Start 10mm below the blue header

        // REPORT CRITERIA heading
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text('REPORT CRITERIA', 14, currentY);
        currentY += 8;

        // Criteria Details Line (adapted for enquiries)
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        const criteriaSummary = getCriteriaSummary(table);
        const splitCriteria = doc.splitTextToSize(criteriaSummary, pageWidth - 28);
        doc.text(splitCriteria, 14, currentY);
        currentY += (splitCriteria.length * doc.getLineHeight()) + 10; // Padding before table


        // --- Main Data Table (adapted for enquiries) ---
        // PDF spec: remove ID and Office, add Owner Name and Notes
        const tableBody = rowsToExport.map(enquiry => {
            const notes = enquiry.additionalNotes ?? enquiry.notes ?? '';
            return [
                getValue(enquiry.status),
                getValue(enquiry.userdetials?.Name), // USER (broker)
                getValue(enquiry.OwnerName), // Owner Name added
                getValue(enquiry.type),
                getValue(enquiry.typeOfProperty),
                getValue(enquiry.address?.suburb),
                getValue(enquiry.CompanyName),
                getValue(enquiry.Email),
                getValue(enquiry.PhoneNumber),
                new Date(getValue(enquiry.enquiryDate, Date.now())).toLocaleDateString(),
                getValue(enquiry.source),
                getValue(enquiry.sizeMin),
                getValue(enquiry.sizeMax),
                getValue(notes, ''),
            ];
        });

        autoTable(doc, {
            startY: currentY,
            head: [[
                'STATUS', 'USER', 'OWNER NAME', 'TYPE', 'PROPERTY TYPE', 'SUBURB', 'COMPANY',
                'EMAIL', 'PHONE', 'ENQUIRY DATE', 'SOURCE', 'MIN SIZE', 'MAX SIZE', 'NOTES'
            ]],
            body: tableBody,
            styles: {
                fontSize: 7,
                cellPadding: 2,
            },
            headStyles: {
                fillColor: [52, 58, 64],
                textColor: 255,
                fontStyle: 'bold',
            },
            margin: { top: currentY, right: 14, bottom: 14, left: 14 },
        });

        doc.save(`Enquiries_${type}_Export.pdf`); // Filename change
        setIsExporting(false);
    };


    const table = useMaterialReactTable({
        columns: enquiryColumns,
        data: useMemo(() => data, [data]),
        enableColumnFilterModes: true,
        enableColumnOrdering: true,
        enableGrouping: true,
        enableEditing: false,
        editingMode: 'row',
        enableColumnPinning: true,
        enableFacetedValues: true,
        enableRowActions: true,
        enableRowSelection: true,
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        state: {
            pagination: {
                pageIndex: 0,
                pageSize: data.length,
            },
        },
        muiTableBodyRowProps: {
            sx: {
                height: "36px", // thinner rows
            },
        },
        muiTableHeadCellProps: {
            sx: {
                padding: "4px 8px",
                fontSize: "0.85rem",
            },
        },

        muiTableContainerProps: {
            sx: {
                maxWidth: "100%",
                overflowX: "auto",
            },
        },

        muiTableBodyCellProps: {
            sx: {
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                padding: "4px 8px",
                fontSize: "0.85rem",
            },
        },

        // ✅ Your table initial state
        initialState: {
            pagination: {
                pageSize: 100,
                pageIndex: 0,
            },
            showColumnFilters: true,
            showGlobalFilter: true,
            columnPinning: {
                left: ['mrt-row-expand', 'mrt-row-select'],
                right: ['mrt-row-actions'],
            },
            ...userInitialState,
        },

        muiSearchTextFieldProps: {
            size: 'small',
            variant: 'outlined',
        },
        muiPaginationProps: {
            color: 'secondary',
            rowsPerPageOptions: [10, 20, 30],
            shape: 'rounded',
            variant: 'outlined',
        },

        // ✅ Remove bottom toolbar & pagination completely
        renderBottomToolbar: false,

    //
        // ✅ Row actions
        renderRowActionMenuItems: ({ row, closeMenu }) => [
            <MenuItem key="Edit" onClick={() => { closeMenu(); edit(row.original); }}>
                <ListItemIcon></ListItemIcon>Edit
            </MenuItem>,
                  <MenuItem key="View" onClick={() => { closeMenu(); navigate("/staffenquirydetails", { state: { item: row.original } }); }}>
                <ListItemIcon></ListItemIcon>View
            </MenuItem>,
            <>
                {row.original?.status !== "Active" ? (
                    <MenuItem key="Unarchive" onClick={() => { closeMenu(); unArchive(row.original); }}>
                        <ListItemIcon></ListItemIcon>Unarchive
                    </MenuItem>
                ) : (
                    <MenuItem key="Archive" onClick={() => { closeMenu(); archive(row.original); }}>
                        <ListItemIcon></ListItemIcon>Archive
                    </MenuItem>
                )}
            </>,
            ,
            <MenuItem key="PullForward" onClick={() => { closeMenu(); pullforward(row.original); }}>
                <ListItemIcon></ListItemIcon>Pull Forward
            </MenuItem>,
        ],

        // ✅ Toolbar override (keeps only your top toolbar)
        renderTopToolbar: ({ table }) => (
            <Box
                sx={(theme) => ({
                    backgroundColor: lighten(theme.palette.background.default, 0.05),
                    display: 'flex',
                    gap: '1rem',
                    p: '8px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                })}
            >

                {/* Right Side - Export + Add */}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', alignItems: 'center' }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={(e) => setExportAnchorEl(e.currentTarget)}
                        endIcon={<ArrowDropDownIcon />}
                        sx={{
                            backgroundColor: 'white',
                            borderColor: 'gray.300',
                            color: 'black',
                            '&:hover': {
                                backgroundColor: '#f0f0f0',
                                borderColor: 'gray.400',
                            },
                        }}
                    >
                        Export Enquiries
                    </Button>

                    <Menu anchorEl={exportAnchorEl} open={exportMenuOpen} onClose={handleExportClose}>
                        <MenuItem onClick={() => { handleExportPDF(table, 'page'); handleExportClose(); }}>
                            Current Page (PDF)
                        </MenuItem>
                        <MenuItem onClick={() => { handleExport(table, 'page'); handleExportClose(); }}>
                            Current Page (XLS)
                        </MenuItem>
                        <MenuItem onClick={() => { handleExportPDF(table, 'filtered'); handleExportClose(); }}>
                            Filtered Results (PDF)
                        </MenuItem>
                        <MenuItem onClick={() => { handleExport(table, 'filtered'); handleExportClose(); }}>
                            Filtered Results (XLS)
                        </MenuItem>
                        <MenuItem onClick={() => { handleExportPDF(table, 'all'); handleExportClose(); }}>
                            All Records (PDF)
                        </MenuItem>
                        <MenuItem onClick={() => { handleExport(table, 'all'); handleExportClose(); }}>
                            All Records (XLS)
                        </MenuItem>
                    </Menu>

                    <Button variant="contained" color="info" onClick={() => navigateToCreateEnquiry()}>
                        Add
                    </Button>
                </Box>
            </Box>
        ),
    });

    return (
        <>
            <MaterialReactTable table={table} />

            {isExporting && (
                <Box sx={{ width: '100%' }}>
                    <LinearProgress color="info" />
                </Box>
            )}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="warning" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            <Dialog open={isModalOpen} onClose={handleCloseModal} fullWidth maxWidth="sm">
                {isModalOpen && (
                    <FormComponent
                        modalType={modalType}
                        onClose={handleCloseModal}
                        onSubmit={handleFormSubmit}
                        data={selectedRow} // This will be the selected enquiry data
                        columns={enquiryColumns} // Pass the enquiry columns to the form component
                    />
                )}
            </Dialog>
        </>
    );
};

export default Material_React_Table;